import { useGetUnreadMessages } from '@agently/api';
import { useEffect, useMemo } from 'react';

import { useChat } from '@agently/components/chat-core';

type BadgeNavigator = Navigator & {
  clearAppBadge?: () => Promise<void>;
  setAppBadge?: (contents?: number) => Promise<void>;
};

const useBadge = () => {
  const { unread } = useChat();
  const { data } = useGetUnreadMessages({
    refetchInterval: 60_000,
    refetchIntervalInBackground: true,
  });

  // Calculate badge value using useMemo
  const badge = useMemo(() => (data?.length ?? 0) + unread, [data, unread]);

  useEffect(() => {
    const badgeNavigator = navigator as BadgeNavigator;
    if (!badgeNavigator.setAppBadge) return;

    const updateBadge = async () => {
      try {
        if (badge > 0) {
          await badgeNavigator.setAppBadge(badge);
          return;
        }

        if (badgeNavigator.clearAppBadge) {
          await badgeNavigator.clearAppBadge();
          return;
        }

        await badgeNavigator.setAppBadge(0);
      } catch {
        // Badge API might be unavailable or permission can be denied.
      }
    };

    void updateBadge();
  }, [badge]);
};

export default useBadge;
